/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_ThighInputs */

const en_us2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halfway between the hip crease and the top of the knee. Standing, feet hip-width apart, weight on both legs.`)
};

const pt_br2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No meio da coxa, entre a dobra do quadril e o topo do joelho. Em pé, pés na largura do quadril, peso nas duas pernas.`)
};

const es_419_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mitad del muslo, entre el pliegue de la cadera y la parte alta de la rodilla. De pie, pies al ancho de la cadera, peso en ambas piernas.`)
};

const pt_pt2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meio da coxa, entre a dobra da anca e o topo do joelho. De pé, pés à largura da anca, peso nas duas pernas.`)
};

const fr_fr2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À mi-chemin entre le pli de la hanche et le haut du genou. Debout, pieds écartés à largeur de hanches, poids sur les deux jambes.`)
};

const de_de2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Mitte zwischen Hüftbeuge und Oberkante des Knies. Im Stehen, Füße hüftbreit, Gewicht auf beiden Beinen.`)
};

const it_it2_body_measures_how_thigh = /** @type {(inputs: Body_Measures_How_ThighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A metà tra la piega dell'anca e la parte alta del ginocchio. In piedi, piedi alla larghezza dei fianchi, peso su entrambe le gambe.`)
};

/**
* | output |
* | --- |
* | "Halfway between the hip crease and the top of the knee. Standing, feet hip-width apart, weight on both legs." |
*
* @param {Body_Measures_How_ThighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_thigh = /** @type {((inputs?: Body_Measures_How_ThighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_ThighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_thigh(inputs)
	if (locale === "es-419") return es_419_body_measures_how_thigh(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_thigh(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_thigh(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_thigh(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_thigh(inputs)
	return en_us2_body_measures_how_thigh(inputs)
});
export { body_measures_how_thigh as "body-measures.how_thigh" }